import React, { useState } from 'react';
import RegistrationModal from './RegistrationModal';

const StatsSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('registration');

  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <>
      <RegistrationModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialType={modalType}
      />
      <div className="py-16 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left: CTA Content */}
            <div>
              <h2 className="text-4xl md:text-6xl font-bold leading-tight">
                Protect Your Brand with Confidence
              </h2>
              <p className="text-xl md:text-2xl text-gray-300 mt-6">
                File your trademark quickly with expert legal support. Fast, affordable, and built for maximum protection.
              </p>
            </div>

            {/* Right: CTA Buttons */}
            <div className="flex flex-col gap-4">
              <button
                onClick={() => openModal('registration')}
                className="group w-full flex items-center justify-center bg-gradient-to-r from-[#168356] to-[#0a5938] hover:from-[#0a5938] hover:to-[#168356] text-white font-bold px-8 py-5 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#168356]/30"
              >
                Start Registration →
              </button>
              
              <button
                onClick={() => openModal('attorney')}
                className="group w-full flex items-center justify-center border-2 border-white/30 hover:border-white text-white font-semibold px-8 py-5 rounded-lg transition-all duration-300 hover:bg-white/10"
              >
                Discuss with Attorney
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsSection;